import type {
  GoalPhaseRecord,
  NutrientGoalRecord,
  ProfileRecord,
  SettingsRecord,
} from "../../records";
import type { DietTrackerDatabase } from "../database";
import { mutateDatabase } from "../mutate";

export class IndexedDbConfigurationRepository {
  constructor(private readonly database: DietTrackerDatabase) {}

  getProfile(): Promise<ProfileRecord | undefined> {
    return this.database.profiles.get("primary");
  }

  putProfile(profile: ProfileRecord): Promise<string> {
    return mutateDatabase(this.database, () => this.database.profiles.put(profile));
  }

  getSettings(): Promise<SettingsRecord | undefined> {
    return this.database.settings.get("settings");
  }

  putSettings(settings: SettingsRecord): Promise<string> {
    return mutateDatabase(this.database, () => this.database.settings.put(settings));
  }

  getActiveGoal(): Promise<GoalPhaseRecord | undefined> {
    return this.database.goalPhases.orderBy("effectiveFrom").last();
  }

  putGoal(goal: GoalPhaseRecord): Promise<string> {
    return mutateDatabase(this.database, () => this.database.goalPhases.put(goal));
  }

  listNutrientGoals(): Promise<NutrientGoalRecord[]> {
    return this.database.nutrientGoals.toArray();
  }

  putNutrientGoal(goal: NutrientGoalRecord): Promise<string> {
    return mutateDatabase(this.database, () => this.database.nutrientGoals.put(goal));
  }

  deleteNutrientGoal(id: string): Promise<void> {
    return mutateDatabase(this.database, () => this.database.nutrientGoals.delete(id));
  }
}
